import React, { useState, useEffect, Fragment } from 'react';
import { BrowserRouter as Router, Link } from "react-router-dom";
import { useMediaQuery } from 'react-responsive'
function SearchAdBanner() {
  const isMobcreen = useMediaQuery({ query: '(min-width: 0px) and (max-width: 992px)' })
  return (
    <Link
      to="/store/deals"
      style={{ position: 'relative' }}>
      {isMobcreen ?
        <img
          src='https://cdn.ebtida.com/1743079511189-goshopright-mob-final.gif'
          style={{ width: '100%', borderRadius: '6px', filter: 'saturate(0.7)' }} /> :
        <img
          src='https://cdn.ebtida.com/1743079490666-goshopright-web-final.gif'
          style={{ width: '100%', borderRadius: '6px', filter: 'saturate(0.7)' }} />
      }
    </Link>
  );
}

export default SearchAdBanner;
